<template>
	<div class="shortcut-keys">
		<div class="tooltip--nav-shortcut__text--mac">
			<kbd class="inline-block bg-shade-3 border border-shade-4 rounded px-2 py-1 leading-none">Cmd</kbd>
			+
			<kbd class="inline-block bg-shade-3 border border-shade-4 rounded px-2 py-1 leading-none">\</kbd>
		</div>
		<div class="tooltip--nav-shortcut__text--windows flex items-center gap-2">
			<kbd class="inline-block bg-shade-3 border border-shade-4 rounded px-2 py-1 leading-none">Ctrl</kbd>
			+
			<kbd class="inline-block bg-shade-3 border border-shade-4 rounded px-2 py-1 leading-none">\</kbd>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'CShortcutKeys'
	};
</script>

<style lang="scss">
.shortcut-keys kbd {
	box-shadow:
		// Unchanging color
		0 1px 1px rgba(black, .2),
		inset 0 2px 0 0 rgba(white, .2);
	font-size: .85em;
}
</style>